import { invariant } from "@epic-web/invariant";
import { useRouteLoaderData } from "react-router";

import type { Theme } from "./settings/theme";

/**
 * @returns the request info from the root loader (throws an error if it does not exist)
 */
export function useRequestInfo() {
  const maybeRequestInfo = useOptionalRequestInfo();
  invariant(maybeRequestInfo, "No requestInfo found in root loader");

  return maybeRequestInfo;
}

export function useOptionalRequestInfo() {
  const data = useRouteLoaderData<{
    requestInfo: {
      userPrefs: { theme?: Theme };
      hints: { theme: Theme | "system" };
      path: string;
    };
  }>("root");

  return data?.requestInfo;
}
